import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { ConsumptionExceptionsComponent } from './consumption-exceptions.component';
import { ConsumptionExceptionsRoutingModule } from './consumption-exceptions-routing.module';

@NgModule({
  declarations: [ConsumptionExceptionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatAutocompleteModule,
    CustomDatePickerModule,
    CustomInputModule,
    PcMultiSelectFilterModule,
    ConsumptionExceptionsRoutingModule,
  ],
  exports: [ConsumptionExceptionsComponent],
})
export class ConsumptionExceptionsModule {}
